import React, { useState } from 'react';
import { Link , useLocation, useHistory} from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../adm_mypageAside";
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import UITextArea from "components/atoms/textarea/UITextArea";
import CommonUtil from "utils/CommonUtil";
import StringUtil from "utils/StringUtil";
import UIUtils from "utils/UIUtils";
import paramStore from "common/page/store/ParamStore";

function ContentsContainer() { 

	const history = useHistory();
	const receivedData = paramStore.getParam("adm0102");
	
	const [repSanPersonNm, setRepSanPersonNm] = useState('');
	const [absnDate, setAbsnDate] = useState('');
	const [absnItemNm, setAbsnItemNm] = useState('');
	const [absnReason, setAbsnReason] = useState('');

	async function initCall() {
		let vRepSanId = "";
		let passFlag = false;
		if(receivedData && receivedData.vREP_SAN_ID) {
			vRepSanId = StringUtil.defaultString(receivedData.vREP_SAN_ID);
			if("" !== vRepSanId) passFlag = true;
		}
		if(passFlag) {
			let param = {"REP_SAN_ID": vRepSanId};
			const response:any = await CommonUtil.execute({
				url: 'adm_0102_r001',
				data: param,
			}).then((response: any) => {
				const result = response;
				if(result != null && result.REP_SAN_PERSON_NM) {
					setAbsnItemNm(StringUtil.defaultString(result.ABSN_ITEM_NM));
					setAbsnReason(StringUtil.defaultString(result.ABSN_REASON));
					setAbsnDate(StringUtil.defaultString(result.ABSN_DATE));
					setRepSanPersonNm(StringUtil.defaultString(result.REP_SAN_PERSON_NM));
				}else {
					errorProc();
				}
			}).catch((error) => {
				CommonUtil.showAxiosError(error);
				return;
			});
		}else {
			errorProc();
		}
	};

	async function errorProc() {
		UIUtils.alert('정상적인 값이 아닙니다. 다시 시도해주세요').then(()=>{
			doList();
		});
    };

	//목록이동
	async function doList() {
		history.push({
			pathname: "/admin/adm_mypage/adm0100",
			state: {data: {}}
		});
    };

	React.useEffect(() => {
		initCall();
    },[])

	return (
		<PageContainer>
			<LayoutAside />
			<div className='fww-con'>
				<ul className="fww-brd">
					<li><Link to="/admin/">홈</Link></li>
					<li><Link to="#">관리자페이지</Link></li>
					<li><Link to="#">마이페이지</Link></li>
				</ul>
				<main className="fww-main">
					<h1 className="tx tx-hd2">부재등록 상세</h1>
					<form className="fo fo-col2">
						<div className="fo-item req">
							<p className="fo-key">부재항목</p>
							<div className="fo-value">
								<UIInput className={'tf tf-md'} value={absnItemNm} readOnly={true}/>
							</div>
						</div>
						<div className="fo-item req">
							<p className="fo-key">부재기간</p>
							<div className="fo-value">
								<div className="hz-root hz-gap5">
									<UIInput className={'tf tf-md w280'} value={absnDate} readOnly={true}/>
								</div>
							</div>
						</div>
						<div className="fo-item fo-m-1-4">
							<p className="fo-key">부재사유</p>
							<div className="fo-value">
								<div className="ta w100p">
									<UITextArea className={'ta-ip'} value={absnReason} attrs={{ rows: 10, readOnly: true }}/>
								</div>
							</div>
						</div>
						<div className="fo-item req">
							<p className="fo-key">직무대리자</p>
							<div className="fo-value">
								<UIInput className={'tf tf-md'} value={repSanPersonNm} readOnly={true}/>
							</div>
						</div>
					</form>
					<div className="hz-root hz-right hz-gap5">
						<Button color="pri-o" size="sm" onClick={()=> doList()}>목록</Button>
					</div>
				</main>
			</div>
		</PageContainer>
	);
}
export default ContentsContainer;